const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/items/$id/builds.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getQueryClient } from "@/lib/client";
import { generateItemMeta } from "@/lib/generate-item-meta";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/items/$id/builds")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context,
    params
  }) => {
    const {
      id
    } = params;
    const {
      queryClient
    } = context;
    await queryClient.prefetchQuery({
      queryKey: ["item", "builds", {
        id
      }],
      queryFn: () => httpClient.get<Build[]>(`/items/${id}/builds`).catch(() => [])
    });
    return {
      id,
      dehydratedState: dehydrate(queryClient)
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("items.notFound"),
          description: i18n.t("items.notFound")
        }]
      };
    }
    const item = getFetchedQuery<SingleItem>(queryClient, ctx.loaderData?.dehydratedState, ["item", {
      id: params.id
    }]);
    if (!item) {
      return {
        meta: [{
          title: i18n.t("items.notFound"),
          description: i18n.t("items.notFound")
        }]
      };
    }
    return {
      meta: generateItemMeta(item, i18n.t("items.builds.title"))
    };
  }
});